import Nullstack from 'nullstack';
export default function IconAward({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-award",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "9",
    r: "6"
  }), "   ", Nullstack.element("path", {
    d: "M12.002 15.003l3.4 5.89l1.598 -3.233l3.598 .232l-3.4 -5.889"
  }), "   ", Nullstack.element("path", {
    d: "M6.802 12.003l-3.4 5.89l3.598 -.233l1.598 3.232l3.4 -5.889"
  }), " ");
}